const CHECKOUT = "checkout";
const CHECKOUT_FORM_DATA = "checkout.form_data";
export const VARIABLE_MODEL = {
  CHECKOUT,
  CHECKOUT_FORM_DATA
};

const PRICEBLOCS = "priceblocs";
export const VARIABLE_SERVICE = {
  PRICEBLOCS
};

export const MODEL_UID_KEY = "modelUid";

const PARAGRAPH = "paragraph";
const TEXT = "text";
const MENTION = "mention";
export const TEMPLATE_EDITOR_NODE = {
  PARAGRAPH,
  MENTION,
  TEXT
};
